import React, { useState } from 'react';
import { View, StyleSheet, LayoutAnimation } from 'react-native';
import Text from 'design-system/Text';
import Button from 'design-system/Button';
import { rem, Spacer } from 'design-system';
import Amplitude from 'utils/amplitude';
import FastImage from 'utils/packages/rnFastImage';
import EMMA_HEART_PNG from 'design-system/img/emma-heart.png';
const strings = {
    questionTitle: 'Enjoying Emma?',
    answerNo: 'No, I don’t',
    answerOkay: 'It’s okay',
    answerYes: 'Yes, it’s my fav!',
    reviewTitle: 'We’re glad to hear that!',
    reviewSubtitle: 'We’d love to hear your thoughts! A quick review helps us grow and keep improving for you',
    reviewButton: 'Leave a review',
};
const ModalRating = ({ onPressed, onLeaveReview }) => {
    const [showLeaveReview, setShowLeaveReview] = useState(false);
    const onPressResponse = (response) => () => {
        const shouldShowLeaveReview = onPressed(response) === 'showLeaveReview';
        Amplitude.logEvent('Transaction.reviewTaken', { value: response });
        if (shouldShowLeaveReview) {
            LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
            setShowLeaveReview(true);
        }
    };
    return (<View style={styles.modal}>
      <View style={styles.modalContainer}>
        <FastImage source={EMMA_HEART_PNG} style={styles.image}/>
        <Spacer h={24}/>
        {showLeaveReview ? (<>
            <Text Text-20 centered>
              {strings.reviewTitle}
            </Text>
            <Spacer.H16 />
            <Text TextThin-14 centered Secondary>
              {strings.reviewSubtitle}
            </Text>
          </>) : (<Text Text-20 centered>
            {strings.questionTitle}
          </Text>)}
        <Spacer h={24}/>
        {showLeaveReview ? (<Button title={strings.reviewButton} brand onPress={onLeaveReview}/>) : (<>
            <Button title={strings.answerNo} brandBorder onPress={onPressResponse('hate')}/>
            <Spacer h={8}/>
            <Button title={strings.answerOkay} brandReversed onPress={onPressResponse('neutral')}/>
            <Spacer h={8}/>
            <Button title={strings.answerYes} brand onPress={onPressResponse('love')}/>
          </>)}
      </View>
    </View>);
};
const styles = StyleSheet.create({
    modal: {
        paddingTop: rem(32),
        borderTopLeftRadius: rem(16),
        borderTopRightRadius: rem(16),
    },
    modalContainer: {
        paddingTop: rem(16),
        alignItems: 'center',
    },
    image: {
        width: rem(80),
        height: rem(76),
    },
});
export default React.memo(ModalRating);
